import React from 'react'
import styled from '@emotion/styled'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { display, DisplayProps, space, SpaceProps } from 'styled-system'
import { css } from '@emotion/core'

const ButtonContainer = styled('button', {
  shouldForwardProp
})`
  height: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 0;
  background: transparent;
  border-radius: 5px;
  box-sizing: content-box;
  cursor: pointer;
  padding: 9px 10px;
  outline: 0;
  ${display}
  ${space}
  ${props => ({ 'background-color': props.backgroundVisible && '#eee' })}
  &:hover {
    background-color: #eee;
  }
`

const line = css`
  display: block;
  width: 22px;
  height: 2px;
  border-radius: 1px;
  background-color: #555;
`

type BurgerButtonProps = DisplayProps &
  SpaceProps & {
  backgroundVisible?: boolean
  onClick: () => void
}

const BurgerButton: React.FC<BurgerButtonProps> = props => {
  return (
    <ButtonContainer {...props}>
      <span css={line}/>
      <span css={line}/>
      <span css={line}/>
    </ButtonContainer>
  )
}

export default BurgerButton
